/**
 * Per-user editor toolbar style, rendered by the layouts as
 * `<body data-editor-toolbar="fixed|floating">`.
 *
 * "floating" (default) shows formatting controls next to the selection.
 * "fixed" pins them in the editor header for every mode.
 */
export const TOOLBAR_FIXED = "fixed"
export const TOOLBAR_FLOATING = "floating"

export function readToolbarPreference(doc = globalThis.document) {
  return doc?.body?.dataset?.editorToolbar === TOOLBAR_FIXED ? TOOLBAR_FIXED : TOOLBAR_FLOATING
}

export function withToolbarPreference(modeConfig, preference) {
  if (preference !== TOOLBAR_FIXED) return modeConfig

  return {
    ...modeConfig,
    layout: {
      ...modeConfig.layout,
      showHeader: true,
      showFloatingToolbar: false,
      showFixedToolbar: true,
    },
  }
}
